import { Button, Grid2, Typography } from "@mui/material"
import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"

import config from "../../config/config.json"

import api from "../../services/api"

function fallbackRender({ error, resetErrorBoundary }) {
    let loading = false

    const sendErrorReport = async () => {
        try {
            loading = true

            await api.post("/settings/errorBoundary", {
                errorMessage: error.message,
                href: window.location.href,
                errorStack: error.stack,
                appName: config.system.name,
            })

            loading = false
        } catch (error) {
            loading = false
            console.error(error)
        }
        resetErrorBoundary()
    }

    return (
        <MainContainer>
            <Grid2 size={{ xs: 12 }}>
                <MainHeader>
                    <Title>O {config.system.name} encontrou um erro</Title>
                </MainHeader>
                <Typography>
                    Estamos coletando informações sobre o erro e encaminhando ao
                    setor responsável
                </Typography>
                <Typography mb={5}>
                    Clique no botão abaixo para voltar para a tela inicial
                </Typography>

                <Button
                    variant="contained"
                    onClick={sendErrorReport}
                    loading={loading}
                >
                    Atualizar
                </Button>
            </Grid2>
        </MainContainer>
    )
}

export default fallbackRender
